/* eslint-disable no-unused-vars */
export default (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(2),
  },
});
